import React from "react";
import Verify from "../common/Verify";
import InvaidInvitation from "../error/InvitationSignUpError";
import { NewWorkspace } from "../workspace/NewWorkspace";

import { verify } from "./op.invite";

const DummySuccess = props => <div>Success</div>;

const verifyInvitation = props => () => {
  const email = props.match.params.email;
  const token = props.match.params.verificationId;
  const ws = props.match.params.ws;
  return verify(email, ws, token);
};

const AcceptInvitation = props => (
  <Verify
    verify={verifyInvitation(props)}
    ErrorPage={<InvaidInvitation />}
    SuccessPage={<NewWorkspace {...props} mode="invitation_signup" />}
  />
);

export default AcceptInvitation;
